import { render } from "./OrderDocumentTranslation.vue?vue&type=template&id=7dbbf005&scoped=true"
import script from "./OrderDocumentTranslation.vue?vue&type=script&lang=js"
export * from "./OrderDocumentTranslation.vue?vue&type=script&lang=js"

import "./OrderDocumentTranslation.vue?vue&type=style&index=0&id=7dbbf005&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7dbbf005"

export default script